import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import AlertComponent from "../components/AlertComponent";
import {
  deleteDevices,
  editDevices,
  getDeviceList,
  getDeviceType,
  postDevices,
} from "../redux/action/deviceAction";
import ModalComponent from "../components/ModalComponent";
import { openForm } from "../redux/slice/deviceSlice";
import { getSitesList } from "../redux/action/sitesAction";
import { SelectInput, TextArea } from "../components/InputComponent";

const FormDevice = ({ param }) => {
  const { idDevices, dataByIdDevices, isOpenForm, state } = useSelector( (state) => state.device );
  // console.log(idDevices)
  const { dataSitesList } = useSelector( (state) => state.sites );
  const { dataDevicesType } = useSelector( (state) => state.device );
  const dispatch = useDispatch();
  const [siteId, setSite] = useState('')
  const [devId, setDevice] = useState('')
  const [optionSites, setOptionSites] = useState([])
  const [optionDevice, setOptionDevice] = useState([])

  const initialValues = {
    devLon: idDevices === '' ? '' : dataByIdDevices.devLon,
    devLat: idDevices === '' ? '' : dataByIdDevices.devLat,
    devAlt: idDevices === '' ? '' : dataByIdDevices.devAlt,
    devType: idDevices === '' ? '' : dataByIdDevices.devType,
    devName: idDevices === '' ? '' : dataByIdDevices.devName,
    devSpecs: idDevices === '' ? '' : dataByIdDevices.devSpecs,
    devOs: idDevices === '' ? '' : dataByIdDevices.devOs,
    devIp: idDevices === '' ? '' : dataByIdDevices.devIp,
    devLocation: idDevices === "" ? "" : dataByIdDevices.devLocation,
    devPort: idDevices === "" ? "" : dataByIdDevices.devPort,
    devUser: idDevices === "" ? "" : dataByIdDevices.devUser,
    devPassword: idDevices === "" ? "" : dataByIdDevices.devPassword,
    devBucket: idDevices === "" ? "" : dataByIdDevices.devBucket,
  };
  // console.log(dataByIdDevices)
  const validationSchema = Yup.object().shape({
    // devName: Yup.string().required("Devices Nama is required!"),
    // devLon: Yup.string().required("Devices Longitude is required!"),
    // devLat: Yup.string().required("Devices Latitude is required!"),
    // devAlt: Yup.string().required("Devices ALT is required!"),
    // devSpecs: Yup.string().required("Device Space is required!"),
    // devOs: Yup.string().required("Device OS is required!"),
    // devIp: Yup.string().required("Device IP is required!"),
    // devName: Yup.string().required("Devices Name is required!"),
  });
  const resetOption = () =>{
    setSite('')
    setDevice('')
  }

  const handleFormSubmit = async (values) => {
    // console.log(values)
    if (state === "add") {
      param.data = values;
      // console.log(param.data);
      dispatch(postDevices(param));
      resetOption()
    } else if (state === "edit") {
      param.data = values;
      param.id = idDevices;
      dispatch(editDevices(param));
      resetOption()
    } else {
      param.id = idDevices;
      dispatch(deleteDevices(param));
      resetOption()
    }
  };

  const newSites = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH LOKASI -', id: '' }]
    dataSitesList.map((row, index) => {
      arr.push({ name: row.siteName, id: row.siteId })
    })
    setOptionSites(arr)
    
  }
  useEffect(() => {
    newSites()
  }, [])
  useEffect(() => {
    if (dataSitesList.length > 0) {
      newSites()
    }
  }, [dataSitesList])

  const newDevice = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH PERANGKAT -', id: '' }]
    dataDevicesType.map((row, index) => {
      arr.push({ name: row.devType, id: row.devType })
    })
    setOptionDevice(arr)
    
  }
  useEffect(() => {
    newDevice()
  }, [])
  useEffect(() => {
    if (dataDevicesType.length > 0) {
      newDevice()
    }
  }, [dataDevicesType])

  useEffect(() => {
    dispatch(getSitesList(param));
    dispatch(getDeviceType(param));
  }, []);

  return state === "delete" ? (
    <AlertComponent
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, state: "close" }))}
      action={() => handleFormSubmit()}
    />
  ) : (
    <ModalComponent
      title={state === "add" ? "TAMBAH PERANGKAT" : "EDIT PERANGKAT"}
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, type: "close" }))}
      idForm="analytic-form"
    >
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit} id="analytic-form">
            <div className="row align-items-center" style={{ color: "white" }}>
              <div className="form-group row mb-3">
                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Name Perangkat
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="devName"
                    id="devName"
                    className="form-control"
                    value={values.devName}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devName && errors.devName && (
                    <span style={{ color: "white" }}>{errors.devName}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Lokasi Perangkat
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <SelectInput
                    onChange={(e) => {
                      // console.log(e.target.value)
                      let event = { target: { name: 'devLocation', value: e.target.value } }
                        setSite(e.target.value)
                        handleChange(event)
                    }}
                    name="devLocation"
                    id="devLocation"
                    value={values.devLocation}
                    option={optionSites}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                      helperText: touched.devLocation && errors.devLocation,
                      error: Boolean(errors.devLocation && touched.devLocation),
                    }}
                  />
                  {touched.devLocation && errors.devLocation && (
                    <span>{errors.devLocation}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Longitude
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="devLon"
                    id="devLon"
                    className="form-control"
                    value={values.devLon}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devLon && errors.devLon && (
                    <span style={{ color: "white" }}>{errors.devLon}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Latitude
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="devLat"
                    id="devLat"
                    className="form-control"
                    value={values.devLat}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devLat && errors.devLat && (
                    <span style={{ color: "white" }}>{errors.devLat}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Altitude
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="number"
                    name="devAlt"
                    id="devAlt"
                    className="form-control"
                    value={values.devAlt}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devAlt && errors.devAlt && (
                    <span style={{ color: "white" }}>{errors.devAlt}</span>
                  )}
                </div>                

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label">
                  Tipe Perangkat
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                   <SelectInput
                      onChange={(e) => {
                        // console.log(e.target.value)
                        let event = { target: { name: 'devType', value: e.target.value } }
                          setDevice(e.target.value)
                          handleChange(event)
                      }}
                      name="devType"
                      id="devType"
                      value={values.devType}
                      option={optionDevice}
                      validation={''}
                      props={{
                      onBlur: handleBlur,
                      helperText: touched.devType && errors.devType,
                      error: Boolean(errors.devType && touched.devType),
                    }}
                  />
                  {touched.devType && errors.devType && (
                    <span>{errors.devType}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Alamat IP
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="devIp"
                    id="devIp"
                    className="form-control"
                    value={values.devIp}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devIp && errors.devIp && (
                    <span style={{ color: "white" }}>{errors.devIp}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Specs Devices
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <TextArea
                    onChange={handleChange}
                    type="text"
                    name="devSpecs"
                    id="devSpecs"
                    className="form-control"
                    value={values.devSpecs}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devSpecs && errors.devSpecs && (
                    <span style={{ color: "white" }}>{errors.devSpecs}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Operasi Sistem Perangkat
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="devOs"
                    id="devOs"
                    className="form-control"
                    value={values.devOs}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devOs && errors.devOs && (
                    <span style={{ color: "white" }}>{errors.devOs}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Nama User Perangkat
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="devUser"
                    id="devUser"
                    className="form-control"
                    value={values.devUser}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devUser && errors.devUser && (
                    <span style={{ color: "white" }}>{errors.devUser}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Password Perangkat
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="devPassword"
                    id="devPassword"
                    className="form-control"
                    value={values.devPassword}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devPassword && errors.devPassword && (
                    <span style={{ color: "white" }}>{errors.devPassword}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Port Perangkat
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="devPort"
                    id="devPort"
                    className="form-control"
                    value={values.devPort}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devPort && errors.devPort && (
                    <span style={{ color: "white" }}>{errors.devPort}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Bucket Perangkat
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <input
                    onChange={handleChange}
                    type="text"
                    name="devBucket"
                    id="devBucket"
                    className="form-control"
                    value={values.devBucket}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.devBucket && errors.devBucket && (
                    <span style={{ color: "white" }}>{errors.devBucket}</span>
                  )}
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </ModalComponent>
  );
};

export default FormDevice;
